import navyWaves from "./navy-waves.svg";
import charcoalGrid from "./charcoal-grid.svg";
import forestDots from "./forest-dots.svg";
import burgundyDiagonal from "./burgundy-diagonal.svg";
import slateSolid from "./slate-solid.svg";
import plumCircles from "./plum-circles.svg";

export const walletCardBackgrounds = [
  { id: "navy-waves", label: "Navy Waves", src: navyWaves },
  { id: "charcoal-grid", label: "Charcoal Grid", src: charcoalGrid },
  { id: "forest-dots", label: "Forest Dots", src: forestDots },
  { id: "burgundy-diagonal", label: "Burgundy Diagonal", src: burgundyDiagonal },
  { id: "slate-solid", label: "Slate", src: slateSolid },
  { id: "plum-circles", label: "Plum Circles", src: plumCircles },
];

export const defaultWalletCardBackgroundId = walletCardBackgrounds[0].id;

export const getWalletCardBackground = (id) =>
  walletCardBackgrounds.find((bg) => bg.id === id) || walletCardBackgrounds[0];
